export default __webpack_public_path__ + "static/media/node-foursquare-3.c1ee48e2.jpg";